import Cart from './Cart';
import { addToCartTrackingEvent } from '../gtm/eventTracking';

export default function() {
  const cart = Cart.getInstance();
  cart.getState().then(state => {
    cart.updateProductCount(state.items);
  });

  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', e => {
    const { target } = e;
    if (target.classList.contains('js-product-add-to-cart')) {
      const { variantId, quantity, cartPage, title, value } = target.dataset;
      const price = value.replace(',', '.');

      if (cartPage && cartPage === 'true') {
        cart.addItem(parseInt(variantId, 10), { quantity }, false);
        addToCartTrackingEvent(price);
        window.dataLayer.push({
          event: 'upselling',
          eventTitel: title,
          eventLabel: price,
          eventValue: price,
        });
      } else {
        cart.addItem(parseInt(variantId, 10), { quantity });
        addToCartTrackingEvent(price);
      }
    }
  });
}
